import React from 'react';
import { NavigationSmall } from './NavigationSmall';
import { NavigationLarge } from './NavigationLarge';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { useDebounce } from '../../../hooks/useDebounce';

interface NavigationProps {
  onBackClick?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({ onBackClick }) => {
  const windowSize = useWindowSize();
  const { width: windowWidth } = useDebounce(windowSize, 200);

  if (windowWidth > 767) return <NavigationLarge onBackClick={onBackClick} />;

  return <NavigationSmall onBackClick={onBackClick} />;
};
